const selectItemHeight = 33;

export const SelectMenuProps = {
  PaperProps: {
    style: {
      maxHeight: selectItemHeight * 4.4,
    },
  },
};
